<template>
  <li
    v-click-outside="() => (isOpen = false)"
    class="dropdown-container"
    @click.stop="toggleMenu()"
  >
    <a :class="{ isOpen }" @click="$emit('show-dropdown')">{{ label }}</a>
    <ul v-show="isOpen" class="dropdown-list">
      <li v-for="(item, index) in items" :key="index">
        <div v-if="item.divider" class="divider" />
        <router-link v-else-if="item.route" :to="item.route">
          <span class="icon">
            <font-awesome-icon :icon="item.icon" />
          </span>
          {{ item.label }}
        </router-link>
        <a
          v-else-if="item.href || item.action"
          :href="item.href"
          @click="() => item.action && item.action()"
        >
          <span class="icon">
            <font-awesome-icon :icon="item.icon" />
          </span>
          {{ item.label }}
        </a>
      </li>
    </ul>
  </li>
</template>

<script>
import vClickOutside from 'v-click-outside';
export default {
  directives: {
    clickOutside: vClickOutside.directive
  },
  props: {
    label: {
      type: String,
      required: true
    },
    items: {
      type: Array,
      required: true,
      validator(value) {
        const valid =
          value.length &&
          value.every(i => i.divider || i.route || i.href || typeof i.action === 'function');

        if (!valid) {
          console.error('Invalid item: ', value);
        }

        return valid;
      }
    },
    currentOpen: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      isOpen: false,
      openMenus: []
    };
  },
  watch: {
    currentOpen(curVal) {
      if (this._uid !== curVal) {
        this.isOpen = false;
      }
    }
  },
  methods: {
    toggleMenu() {
      this.$emit('i-am-open', this._uid);
      this.isOpen = !this.isOpen;
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/app/styles/colors.scss';
.dropdown-container {
  background: $nav-dark;
  color: $nav-medium;

  a {
    text-decoration: none;
    color: inherit;
    padding: 10px 1em;
    display: inline-block;
    width: 100%;
    height: 100%;
    cursor: pointer;

    &:hover,
    &.isOpen {
      color: $nav-dark;
      background: $nav-medium;
    }

    > .icon {
      display: inline-block;
      margin-left: -10px;
      width: 30px;
      text-align: center;
    }
  }

  .dropdown-list {
    position: absolute;
    z-index: 999;
    list-style: none;
    margin: 0;
    padding: 0;
    color: $nav-dark;
    background: $nav-medium;
    border: 2px solid $nav-dark;
    margin-top: 4px;

    a:hover {
      color: $nav-dark;
      background: $nav-light;
    }

    .divider {
      height: 1px;
      background: $nav-dark;
    }

    li:first-child,
    li:last-child {
      .divider {
        display: none;
      }
    }
  }
}

@media only screen and (max-width: 768px) {
  .dropdown-container {
    width: 100%;
  }
  .dropdown-container .dropdown-list {
    width: 100%;
  }
}
</style>
